<template>
  <div class="apiToolPage">
    <div class="content-box">
      <div class="content-body">
        <div class="page-title">发券工具</div>


        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="创建券包" name="first">

            <el-form ref="form" :model="form" label-width="90px">
              <el-form-item label="券包类型:">
                <el-radio-group v-model="form.account_type">
                  <el-radio :label=1>用户货运券</el-radio>
                  <el-radio :label=2>企业货运券</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item v-if="form.account_type === 1" label="业务券类型:">
                <el-radio-group v-model="form.business_type">
                  <el-radio :label=4>小B货运券</el-radio>
                  <el-radio :label=3>大货车券</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="券类型:">
                <el-radio-group v-model="form.discount_type" @change="discountTypeChange">
                  <el-radio :label=2>折扣券</el-radio>
                  <el-radio :label=1>立减券</el-radio>
                </el-radio-group>
              </el-form-item>

              <template v-if="this.is_rate">
                <el-form-item label="折扣比例:" :label-width="90" prop="discount_rate" class="nonce_str-item"
                              :rules="rules.discount_rate" style="margin-left: -10px">
                  <el-input v-model="form.discount_rate" style="width: 295px"
                            onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"><i slot="suffix"
                                                                                        style="font-style:normal;margin-right: 10px;">%</i>
                  </el-input>
                </el-form-item>

                <el-form-item label="最高优惠:" :label-width="90" prop="discount_amount" class="nonce_str-item"
                              :rules="rules.discount_amount" style="margin-left: -10px">
                  <el-input v-model="form.discount_amount" style="width: 295px"
                            onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"><i slot="suffix"
                                                                                        style="font-style:normal;margin-right: 10px;">元</i>
                  </el-input>
                </el-form-item>
              </template>

              <template v-if="this.is_decrease">
                <el-form-item label="立减金额:" :label-width="90" prop="discount_amount" class="nonce_str-item"
                              :rules="rules.discount_amount" style="margin-left: -10px">
                  <el-input v-model="form.discount_amount" style="width: 295px"
                            onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"><i slot="suffix"
                                                                                        style="font-style:normal;margin-right: 10px;">元</i>
                  </el-input>
                </el-form-item>
              </template>


              <template v-if="this.is_packet">
                <el-form-item label="券包id:">
                  <span v-model="packet_id" style="width: 295px">{{ packet_id }}</span>
                </el-form-item>
              </template>

              <el-form-item>
                <el-button type="primary" @click="onCreate()">创建</el-button>
              </el-form-item>

            </el-form>


          </el-tab-pane>
          <el-tab-pane label="发券" name="second">
            <el-form ref="form1" :model="form" label-width="80px">
              <el-form-item label="券包id:" :label-width="90" prop="picket_ids" class="nonce_str-item"
                            :rules="rules.packet_ids" style="margin-left: -10px">
                <el-input v-model="form.picket_ids" style="width: 295px"
                          onkeyup="this.value = this.value.replace(/[^\d.]/g,'');">
                </el-input>
              </el-form-item>

              <el-form-item label="手机号:" :label-width="90" prop="reg_mobile" :rules="rules.reg_mobile"
                            style="margin-left: -10px">
                <el-input v-model="form.reg_mobile" style="width: 295px"
                          onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"></el-input>
              </el-form-item>

              <el-form-item label="发券数量:" :label-width="90" prop="send_count" :rules="rules.send_count"
                            style="margin-left: -10px">
                <el-input v-model="form.send_count" style="width: 295px"
                          onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"></el-input>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="onSend()">发送</el-button>
              </el-form-item>

              <template v-if="this.is_response">
                <el-form-item label="券包数据:">
                  <vue-json-editor
                      v-model="response_data"
                      :showBtns="false"
                      :mode="'code'"
                      lang="zh"
                  />
                </el-form-item>
              </template>
            </el-form>
          </el-tab-pane>
        </el-tabs>


      </div>
    </div>
  </div>
</template>

<script>
import vueJsonEditor from 'vue-json-editor';

export default {
  name: "couponToolPage",
  data() {
    let phoneCheck = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号码'));
      } else if (value && !this.$config.regCommon.phone.test(value)) {
        callback(new Error('请输入正确的手机号码'));
      } else {
        callback();
      }
    }
    return {
      activeName: 'first',
      tabsActive: "first",
      form: {
        account_type: 1,
        discount_type: 2,
        discount_amount: '',
        discount_rate: null,
        business_type: 4,
        amount: '',
        money: '',
        reg_mobile: '',
        picket_ids: '',
        send_count: ''
      },
      balance: '',
      curEnv: '',
      is_sandbox: true,
      is_rate: true,
      is_decrease: false,
      is_packet: false,
      packet_id: '',
      is_response: false,
      response_data: '',
      rules: {
        reg_mobile: [
          {required: true, message: '请输入手机号码', trigger: 'blur'},
          {min: 11, max: 11, message: '请输入11位手机号码', trigger: 'blur'}
        ],
        discount_rate: [
          {required: true, message: '请输入折扣比例', trigger: 'blur'}
        ],
        discount_amount: [
          {required: true, message: '请输入金额', trigger: 'blur'},
        ],
        packet_ids: [
          {required: true, message: '请输入券包id', trigger: 'blur'},
        ],
        send_count: [
          {required: true, message: '请输入发券数量', trigger: 'blur'},
        ],
      },
    }
  },
  components: {
    vueJsonEditor
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    discountTypeChange() {
      if (this.form.discount_type === 2) {
        this.is_rate = true
        this.is_decrease = false
      } else {
        this.is_rate = false
        this.is_decrease = true
      }
      this.$refs.form && this.$refs.form.resetFields();  //清空验证
    },
    getPath() {
      let env = this.$config.env;
      if (env === 'prd') {
        return '/sandbox'
      }
      return ''
    },
    onCreateCheck() {
      this.$refs.form.validate(valid => {
        if (!valid) {
          throw ''
        }
      })
      if (this.form.discount_amount <= 0) {
        if (this.is_decrease) {
          throw ("立减金额最少1")
        } else {
          throw ("优惠金额最少1")
        }
      }
      if (this.is_rate && this.form.discount_rate > 100) {
        throw ("折扣比例不能超过100")
      }
    },
    onCreate() {
      try {
        this.onCreateCheck()
      } catch (e) {
        if (e !== '') {
          this.$message.error(e)
        }
        return
      }

      this.$axios.post(this.getPath() + "/ajax/coupon/add", {
            account_type: this.form.account_type,
            discount_type: this.form.discount_type,
            discount_amount: this.form.discount_amount,
            discount_rate: this.form.discount_rate,
            business_type: this.form.business_type
          },
          {
            headers: {
              'from': 'open',   //标记来自于门户的请求
            },
          }).then(res => {
        this.hideCommonLoading();
        if (res.data.ret === 0) {
          this.is_packet = true
          this.packet_id = res.data.data
          return
        }
      }).catch((e) => {
      }).finally(
      );
    },
    onSendCheck() {
      this.$refs.form1.validate(valid => {
        if (!valid) {
          throw ''
        }
      })
      if (this.form.send_count > 30) {
        throw ("单次发券数量不能超过30")
      }

      if (this.form.send_count < 1) {
        throw ("单次发券数量至少1")
      }
    },
    onSend() {
      try {
        this.onSendCheck()
      } catch (e) {
        if (e !== '') {
          this.$message.error(e)
        }
        return
      }

      this.$axios.post(this.getPath() + "/ajax/coupon/send", {
            packet_ids: this.form.picket_ids,
            reg_mobile: this.form.reg_mobile,
            count: this.form.send_count
          },
          {
            headers: {
              'from': 'open',   //标记来自于门户的请求
            },
          }).then(res => {
        this.hideCommonLoading();
        if (res.data.ret === 0) {
          this.is_response = true
          this.response_data = res.data.data.success
          return
        }
      }).catch((e) => {
      }).finally(
      );
    },
  },
}
</script>

<style lang="scss">

.apiToolPage {
  min-width: 1180px;
  width: 60%;
  padding: 20px 20px 30px 20px;
  margin: 0 auto;


  .content-box {
    position: relative;
    min-height: 300px;
    margin-top: 25px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);

    .content-body {
      padding: 0 0 0 0;
    }

    .el-form {
      padding: 5px 340px 10px 100px;
    }

    .el-tabs__nav-scroll {
      padding: 4px 340px 0px 95px;
    }

    .el-form-item__error {
      color: #F56C6C;
      font-size: 12px;
      line-height: 1;
      padding-top: 4px;
      margin-left: 95px;
      position: absolute;
      top: 100%;
      left: 0;
    }
  }
}


.access_token-item .el-form-item__label {
  margin-left: -7px;
}

.nonce_str-item .el-button {
  margin-left: 18px;
}

.timestamp-item .el-button {
  margin-left: 18px;
}

.request_body_data-item .el-textarea__inner {
  width: 900px;
  height: 260px;
}

.api-content-box {
  width: 100%;
  padding: 22px 25px 25px 270px;
  box-sizing: border-box;

  .part-title {
    width: 100%;
    line-height: 35px;
    color: #424456;
    font-size: 15px;
    padding-left: 2px;
    border-bottom: 1px solid #F2F2F2;
    font-weight: bold;
  }

  .part-content {
    width: 100%;
    padding: 15px 3px 20px 5px;
    box-sizing: border-box;
  }

  .json-box {
    padding: 15px;
    max-height: 520px;
    font-size: 13px;
    line-height: 15px;
    background: #F7F7F7;
    box-sizing: border-box;
    overflow: auto;
  }

  .info-row {
    color: #212121;
    font-size: 14px;
    line-height: 24px;

    .info-label {
      display: inline-block;
      width: 90px;
      vertical-align: top;
    }

    .info-value {
      display: inline-block;
      width: 600px;
      vertical-align: top;
      color: #666;
    }

    .info-tag {
      display: inline-block;
      width: 60px;
      height: 24px;
      font-size: 12px;
      line-height: 24px;
      text-align: center;
      background: #E4E6F4;
      border-radius: 2px;
      transform: scale(.88);
      transform-origin: left;
      margin-right: -5px;
    }

    .tag-position-top {
      position: relative;
      top: -1px;
    }
  }


}

.textarea {
  width: 100%;
  min-height: 120px;
  max-height: 300px;
  margin-left: auto;
  margin-right: auto;
  padding: 3px;
  outline: 0;
  border: 1px solid #a0b3d6;
  font-size: 12px;
  line-height: 24px;
  word-wrap: break-word;
  overflow-x: hidden;
  overflow-y: auto;
  //border-color: rgba(82, 168, 236, 0.8);
  //box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1), 0 0 8px rgba(82, 168, 236, 0.6);
}

.jsoneditor-poweredBy {
  display: none;
}

div.jsoneditor {
  color: #1A1A1A;
  border: 1px solid #F16222;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  padding: 0;
  line-height: 100%;
}

div.jsoneditor-menu {
  width: 100%;
  height: 35px;
  padding: 2px;
  margin: 0;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: white;
  background-color: #F16222;
  border-bottom: 1px solid #F16222;
}


.signature-body {
  min-height: 200px;
  width: 927px;
  margin-left: 80px;
  margin-top: 20px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  color: #000000;
  background-color: #F0F0F0;

  .sign-title-A {
    padding: 22px 0 0 25px;
  }

  .sign-title-B {
    padding: 22px 0 0 35px;
  }

  .sign-content-A {
    margin: 0 0 0 15px;
  }

  .sign-content-B {
    margin: -21px 0 0 80px;
    word-break: normal;
    width: auto;
    display: block;
    white-space: pre-wrap;
    word-wrap: break-word;
    overflow: hidden;
  }

}

.api-content-box {
  width: 100%;
  padding: 22px 25px 25px 270px;
  box-sizing: border-box;

  .part-content {
    width: 100%;
    padding: 15px 3px 20px 5px;
    box-sizing: border-box;
  }
}

.response-body {
  min-height: 200px;
  width: 927px;
  margin-left: -2px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  color: #000000;
  background-color: #F0F0F0;

}

.codeView {
  margin: 20px -265px 0px 80px;
}

textarea.jsoneditor-text, .ace-jsoneditor {
  min-height: 200px
}

label.el-form-item__label {
  width: 90px;
}


</style>


// WEBPACK FOOTER //
// src/components/help/coupon.vue